import { Paged } from 'domains/appDomain';
import {
  NetworkMember,
  PartialMember,
  UpdateNetworkMember,
} from 'domains/networkDomain';
import { Organization } from 'domains/orgDomain';
import api from 'utils/api';

const networkService = {
  getMembers: async (networkId: number) => {
    return api.get<NetworkMember[]>(
      `/api/networks/${networkId}/members/list/all`
    );
  },

  getJoinedMembers: async (orgId: number, size: number, page: number) => {
    return api.post<Paged<NetworkMember>>(
      `/api/networks/${orgId}/members/list?size=${size}&page=${page - 1}`,
      {
        memberId: orgId,
      }
    );
  },

  addMember: async (member: PartialMember) => {
    return api.post(`/api/networks/${member.networkId}/members`, {
      ...member,
      id: member.id || 0,
    });
  },

  updateMember: async (member: UpdateNetworkMember) => {
    return api.put(
      `/api/networks/${member.networkId}/members/${member.id}`,
      member
    );
  },

  deleteMember: async (member: PartialMember) => {
    return api.delete(`/api/networks/${member.networkId}/members/${member.id}`);
  },

  getNetworksByMemberId: async (memberId: number) => {
    return api.get<NetworkMember[]>(`/api/networks/${memberId}`);
  },

  getAllNetworkOrgs: async (memberId: number) => {
    return api.get<Organization[]>(
      `/api/networks/${memberId}/all-network-orgs`
    );
  },
  getIsMember: async (networkId: number) => {
    return api.get<boolean>(`/api/networks/${networkId}/is-member`);
  },
};
export default networkService;
